﻿$.fn.dxCtrlContentTotalSupport = function custom_dxCtrlContentTotalSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontenttotalsupport dx-ctrl");
        this.createInstance(new cdxCtrlContentTotalSupport(this, option));
    }
    return this;
}

window.cdxCtrlContentTotalSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.isExterne == "undefined") option.isExterne = true

    var $DivContainer = null
    var bddCptGest = null
    var jauge = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        container.css({
            "position": "relative",
            //"background": "#363640",
            //"background": "-webkit-linear-gradient(0deg, #363640 0%, #000000 100%)",
            //"background": "linear-gradient(0deg, rgb(54, 54, 64) 0%, rgb(0, 0, 0) 100%)"
        })
        var $DivTitle = $("<div style='position:absolute;top:0px;left:0px;width:50px;transform:rotate(180deg);writing-mode:tb-rl;font-size:280%;padding-bottom:10px;' class='dx-theme-accent-as-text-color'/>").appendTo(container)
        $DivTitle.html("Support <span style='font-family:bangers;'>" + parametre.nom + "</span>")
        if (parametre.is_generique) $DivTitle.html("Support")
        if (parametre.isMobile) $DivTitle.hide()
        $DivContainer = $("<div style='position:absolute;top:0px;left:50px;width:calc(100% - 50px);height:100%;'/>").appendTo(container)
        if (parametre.isMobile) $DivContainer.css({ "width": "100%" ,"left":"0"})
        //if (option.bddCtrl.theme.contains(".light.")) {
        //    container.css({
        //        "background": "linear-gradient(0deg, rgb(54, 54, 64) 0%, rgb(255, 255, 255) 100%)"
        //    })
        //}

        if (option.isGestionnaire) {
            //on est sur la base de gestion
            bddGest = option.bddCtrl
            //on affiche la liste de tous les tickets
            mAfficheGrid()
        } else {
            if (typeof option.idSupportTicket != 'undefined' && option.idSupportTicket != "0" &&
                (typeof option.idCompteClient == 'undefined' || option.idCompteClient == null) &&
                (typeof option.idUtilisateurClient == 'undefined' || option.idUtilisateurClient == null)) {
                //on a juste un idSupportTicket
                //on récupere idCompteClient && idUtilisateur du ticket
                option.bddCtrl.mAjaxCall({
                    command: "getidcptcliidutifromticket",
                    id_support_ticket: option.idSupportTicket
                }, function (data) {
                    if (typeof data.id_compte_client != 'undefined') {
                        option.idCompteClient = data.id_compte_client
                        option.idUtilisateurClient = data.id_utilisateur
                        mConstruit()
                    }
                })
            } else if (typeof option.idCompteClient != 'undefined' && option.idCompteClient != null) {
                //on a un compte client
                if (typeof option.idUtilisateurClient != 'undefined' && option.idUtilisateurClient != null && option.idUtilisateurClient != "0") {
                    //on a un utilisateur
                    if (!option.bddCtrl.isAuthentified()) {
                        //page de login support
                        option.bddCtrl.mAjaxCall({
                            command: "getutiadresseemailfromid",
                            idCompteClient: option.idCompteClient,
                            id_utilisateur: option.idUtilisateurClient
                        }, function (data) {
                            if (typeof data.adresse_email != 'undefined') {
                                mAffichePageLogin(data.adresse_email)
                            } else {
                                mAffichePageLogin()
                            }
                        })
                    } else {
                        //on est dans l'app du client
                        mAfficheGrid()
                    }
                } else {
                    //on a pas d'utilisateur
                    //on vérifie si on a une base sur le comptecli
                    option.bddCtrl.mAjaxCall({
                        command: "cptclihasmotdepassehasbase",
                        id_compte_client: option.idCompteClient
                    }, function (data) {
                        if (data.has_nom_base == "1") {
                            //on a une base 
                            //on redirige sur la page de login de l'application avec l'email
                            window.open(parametre.url_appli + "?emalog=" + data.adresse_email + "&support=1&id_ticket=" + option.idSupportTicket, "_self")
                        } else if (data.has_mot_de_passe == "1") {
                            //on a un mot de passe sur le compte client
                            //page de login support
                            mAffichePageLogin(data.adresse_email)
                        } else {
                            //on a pas de mot de passe sur le compte client
                            //on envoi un mail de réinitialisation mot de passe
                            mAffichePageReinitPwd(data.adresse_email, true)
                        }
                    })
                }
            } else {
                //on a pas de compte client défini
                //page de login support
                mAffichePageLogin()
            }
        }
    }

    function mAffichePageLogin(AdrEmail) {
        $DivContainer.empty()
        $("<div/>").appendTo($DivContainer).dxCtrlLoginSupport({
            bddCtrl: option.bddCtrl,
            adresseEmail: AdrEmail,
            onDemandeReinitPwd: function () {
                mAffichePageReinitPwd(AdrEmail)
            },
            onValidateCnx: function (idCompteClient, idUtilisateur) {
                option.idCompteClient = idCompteClient
                option.idUtilisateurClient = idUtilisateur
                mAfficheGrid()
            }
        })
    }
    function mAffichePageReinitPwd(AdrEmail, sansMotDePasse) {
        $DivContainer.empty()
        $("<div/>").appendTo($DivContainer).dxCtrlReinitPwdSupport({
            bddCtrl: option.bddCtrl,
            adresseEmail: AdrEmail,
            sansMotDePasse: sansMotDePasse,
            onClose: function () {
                mAffichePageLogin(AdrEmail)
            }
        })
    }
    var dxGridSupport = null
    function mAfficheGrid() {
        $DivContainer.empty()
        if (bddCptGest == null) {
            if (!option.bddCtrl.nom_base.endsWith("_aagest")) {
                jauge.mShow()
                bddCptGest = new cBdd(parametre.code_appli + "_aagest", { allowMsgEmail: false, allowGeocode: false })
                bddCptGest._disableInitPara = true //on est sur un achat/support desactive l'init des para
                bddCptGest.mInit(function () {
                    mAfficheGrid()
                })
                return
            } else {
                bddCptGest = option.bddCtrl
            }
        }

        var $DivGrid = $("<div style='height:100%;display:flex;justify-content:center;'/>").appendTo($DivContainer)
        var opt = {
            bddCtrl: bddCptGest,
            bddUti: option.bddCtrl,
            isGestionnaire: option.isGestionnaire,
            isExterne: option.isExterne,
            onDemandeCreateNewSupport: function () { Me.mShowNewSupport() },
            onDemandeAfficheSupport: function (idSupportTicket) { Me.mShowSupport(idSupportTicket) }
        }
        if (option.isGestionnaire) {
            opt.idUtilisateurGest = option.idUtilisateurGest
        } else {
            opt.idUtilisateurClient = option.idUtilisateurClient
            opt.idCompteClient = option.idCompteClient
        }
        dxGridSupport = $("<div style='width:100%;max-width:800px;height:100%;'/>").appendTo($DivGrid).dxCtrlGridSupport(opt)

        if (typeof option.idSupportTicket != 'undefined') {
            Me.mShowSupport(option.idSupportTicket)
            delete option.idSupportTicket
        }
        jauge.mHide()
    }

    this.mShowSupport = function (idSupportTicket) {
        var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;' class='dx-overlay-shader'/>").appendTo($DivContainer)
        var $DivInner = $("<div style='width:100%;height:100%;position:relative;'/>").appendTo($DivShading)
        var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;'/>").appendTo($DivInner)
        var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;padding:5px;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeSupport({
            bddCtrl: bddCptGest,
            isGestionnaire: option.isGestionnaire,
            idSupportTicket: idSupportTicket,
            idCompteClient: option.idCompteClient,
            idUtilisateurClient: option.idUtilisateurClient,
            idUtilisateurGest: option.idUtilisateurGest,
            isExterne: option.isExterne,
            //onValideTicket: function (e) {
            //    dxGridSupport.mReloadData()
            //},
            onDemandeNewSupportGestionnaire: function (idCompteClient, idUtiCptCli) {
                Me.mShowNewSupport("", [], idCompteClient, idUtiCptCli)
            },
            onClose: function () {
                $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
            }
        }).dxCtrlContentDemandeSupport("instance")
        $DivShading.fadeIn(300)
    }

    this.mShowNewSupport = function (htmlText, lstUrlFile, idCompteClient, idUtilisateurCompteClient) {
        if (option.isGestionnaire) {
            if (idCompteClient) {
                mShowNewSupportInterne(idCompteClient, idUtilisateurCompteClient)
            } else {
                option.bddCtrl.mAjaxCall({ "command": "getlstcompteclientfrombddgest" }, function (data) {
                    if (!data.lst_data || data.lst_data.length == 0) {
                        mNotify("Aucun compte client", "error", 6000)
                        return
                    }
                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        position: {
                            my: "right top",
                            at: "right top",
                            of: "body"
                        },
                        hideOnOutsideClick: true,
                        width: 350,
                        height: "100%",
                        showTitle: true,
                        showMaximize: false,
                        title: "Sélectionner un client",
                        contentTemplate: function (contentElement) {
                            //var ds = [{ key: "Contact", items: [] }, { key: "Structure", items: [] }]
                            data.lst_data.forEach(function (item) {
                                if (item.id_utilisateur_client == null) { item.key = "Structure" } // ds[1].items.push(item) }
                                else { item.key = "Contact" }// ds[0].items.push(item) }
                            })
                            var dxList = $("<div/>").appendTo(contentElement).dxList({
                                dataSource: new DevExpress.data.DataSource({
                                    store: data.lst_data,
                                    group: "key"
                                }),
                                //dataSource: ds,
                                height: '100%',
                                //grouped: true,
                                //collapsibleGroups: true,
                                searchEnabled: true,
                                searchExpr: ['nom_str', 'con_nom', 'adresse_email'],
                                grouped: true,
                                collapsibleGroups: true,
                                //selectByClick: true,
                                groupTemplate(data) {
                                    return $(`<div style='font-family:barlow condensed;font-size:120%' class='dx-theme-accent-as-text-color'>${data.key}</div>`);
                                },
                                //groupTemplate(data) {
                                //    return $(`<div style='font-family:barlow condensed;font-size:120%' class='dx-theme-accent-as-text-color'>${data.type_filtre}</div>`);
                                //},
                                itemTemplate: function (itemData, itemIndex, itemElement) {
                                    itemElement.css("padding", "5px")
                                    itemElement.css("font-family", "barlow condensed")
                                    itemElement.addClass("state-hover")
                                    if (itemData.nom_str) $("<span/>").appendTo(itemElement).text(itemData.nom_str)
                                    if (itemData.con_nom) $("<span/>").appendTo(itemElement).text(" " + itemData.con_nom)
                                    $("<span/>").appendTo(itemElement).html(" <u>" + itemData.adresse_email + "</u>")
                                    if (itemData.nom_base && itemData.nom_base.length > 0) itemElement.css("font-weight", "bold")
                                },
                                onItemClick(e) {
                                    debugger
                                    var items = e.component.option("items")
                                    itemData = items[e.itemIndex.group].items[e.itemIndex.item]
                                    mShowNewSupportInterne(itemData.id_compte_client, itemData.id_utilisateur_client)
                                    //var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;'/>").appendTo($DivContainer)
                                    //var $DivInner = $("<div style='width:100%;height:100%;position:relative;'  class='dx-overlay-shader dx-popup-wrapper'/>").appendTo($DivShading)
                                    //var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;' class='dx-overlay-content'/>").appendTo($DivInner)
                                    //var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeNewSupport({
                                    //    bddCtrl: bddCptGest,
                                    //    isGestionnaire: option.isGestionnaire,
                                    //    idCompteClient: itemData.id_compte_client,
                                    //    idUtilisateurClient: itemData.id_utilisateur_client,
                                    //    idUtilisateurGest: option.idUtilisateurGest,
                                    //    htmlText: htmlText,
                                    //    lstUrlFileJoinStart: lstUrlFile,
                                    //    onClose: function () {
                                    //        $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
                                    //    }
                                    //}).dxCtrlContentDemandeNewSupport("instance")
                                    //$DivShading.fadeIn(300)
                                }
                            })
                        }
                    }).dxCtrlPopupBase("instance")
                    popup.show()
                })
            }

            function mShowNewSupportInterne(idCompteClient, idUtilisateurCompteClient) {
                var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;'/>").appendTo($DivContainer)
                var $DivInner = $("<div style='width:100%;height:100%;position:relative;'  class='dx-overlay-shader dx-popup-wrapper'/>").appendTo($DivShading)
                var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;' class='dx-overlay-content'/>").appendTo($DivInner)
                var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeNewSupport({
                    bddCtrl: bddCptGest,
                    isGestionnaire: option.isGestionnaire,
                    idCompteClient: idCompteClient,
                    idUtilisateurClient: idUtilisateurCompteClient,
                    idUtilisateurGest: option.idUtilisateurGest,
                    htmlText: htmlText,
                    lstUrlFileJoinStart: lstUrlFile,
                    onClose: function () {
                        $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
                    }
                }).dxCtrlContentDemandeNewSupport("instance")
                $DivShading.fadeIn(300)
            }
        } else {
            var $DivShading = $("<div style='width:100%;height:100%;position:absolute;z-index:2;display:none;top:0;right:0;'/>").appendTo($DivContainer)
            var $DivInner = $("<div style='width:100%;height:100%;position:relative;'  class='dx-overlay-shader dx-popup-wrapper'/>").appendTo($DivShading)
            var $DivInnerInner = $("<div style='position:absolute;top:0;right:0;height:100%;" + ((option.isGestionnaire) ? "" : "max-width:600px;") + "width:100%;' class='dx-overlay-content'/>").appendTo($DivInner)
            var dxPopupTicket = $("<div class='dx-theme-material-typography' style='height:100%;'/>").appendTo($DivInnerInner).dxCtrlContentDemandeNewSupport({
                bddCtrl: bddCptGest,
                isGestionnaire: option.isGestionnaire,
                idCompteClient: option.idCompteClient,
                idUtilisateurClient: option.idUtilisateurClient,
                idUtilisateurGest: option.idUtilisateurGest,
                htmlText: htmlText,
                lstUrlFileJoinStart: lstUrlFile,
                onClose: function () {
                    $DivShading.fadeOut(300, function () { dxPopupTicket.element().remove() })
                }
            }).dxCtrlContentDemandeNewSupport("instance")
            $DivShading.fadeIn(300)
        }
    }

    mConstruit();

}